export default __webpack_public_path__ + "static/Edita_Prima_photo_bg_careers_home-fbacf3843575bb650cde1524d78c9560.jpg";